export default "__VITE_ASSET__BrZjjXkl__"